var React = require('react');

function ThumbsUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.5 22H4.5C3.96957 22 3.46086 21.7893 3.08579 21.4142C2.71071 21.0391 2.5 20.5304 2.5 20V13C2.5 12.4696 2.71071 11.9609 3.08579 11.5858C3.46086 11.2107 3.96957 11 4.5 11H7.5M14.5 9V5C14.5 4.20435 14.1839 3.44129 13.6213 2.87868C13.0587 2.31607 12.2956 2 11.5 2L7.5 11V22H18.78C19.2623 22.0055 19.7304 21.8364 20.0979 21.524C20.4654 21.2116 20.7077 20.7769 20.78 20.3L22.16 11.3C22.2035 11.0134 22.1842 10.7207 22.1033 10.4423C22.0225 10.1638 21.8821 9.90629 21.6919 9.68751C21.5016 9.46873 21.2661 9.29393 21.0016 9.17522C20.7371 9.0565 20.4499 8.99672 20.16 9H14.5Z","stroke":"#FF8F0C","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ThumbsUp.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none"};

module.exports = ThumbsUp;

ThumbsUp.default = ThumbsUp;
